import { render, staticRenderFns } from "./ImageWidget.vue?vue&type=template&id=860bd3ea&scoped=true"
import script from "./ImageWidget.vue?vue&type=script&lang=js"
export * from "./ImageWidget.vue?vue&type=script&lang=js"
import style0 from "./ImageWidget.vue?vue&type=style&index=0&id=860bd3ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "860bd3ea",
  null
  
)

export default component.exports